/* Small presentation safeguards; primary cleanup and products are rendered by Liquid. */
(() => {
  'use strict';
  const normalize = value => (value || '').replace(/\s+/g, ' ').trim();
  function init(root) {
    if (root.dataset.egBlogReady) return;
    root.dataset.egBlogReady = 'true';
    const body = root.querySelector('.article-template__content');
    if (!body) return;
    const title = normalize(root.querySelector('.article-template__title')?.textContent);
    body.querySelectorAll('h1').forEach(heading => {
      if (title && normalize(heading.textContent) === title) heading.remove();
    });
    body.querySelectorAll('header').forEach(header => {
      if (!normalize(header.textContent) && !header.querySelector('img,video,iframe')) header.remove();
    });
    // An explicit broken editorial image is removed only after its load fails.
    // Product images retain their original link/title/price if their CDN is temporarily unavailable.
    body.querySelectorAll('img').forEach(img => {
      if (img.closest('[data-eg-blog-products],[data-egifts-legacy-products]')) return;
      const failed = () => {
        const figure = img.closest('figure');
        img.remove();
        if (figure && !figure.querySelector('img,video,iframe') && !normalize(figure.textContent)) figure.remove();
      };
      if (!img.getAttribute('src') && !img.getAttribute('srcset') && !img.dataset.src) failed();
      else if (img.complete && img.naturalWidth === 0) failed();
      else img.addEventListener('error', failed, { once: true });
    });
    body.querySelectorAll('table').forEach(table => {
      if (table.parentElement.classList.contains('eg-blog-table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'eg-blog-table-scroll';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', 'Tabela. Przewiń w poziomie, aby zobaczyć wszystkie kolumny.');
      table.before(wrapper);
      wrapper.append(table);
    });
    // Reuse an existing gift section when present, retaining its anchor and introduction.
    const products = body.querySelector(':scope > [data-eg-blog-products]');
    const slot = body.querySelector('section#prezenty, section#prezent');
    if (products && slot && !slot.querySelector('[data-egifts-legacy-products]')) {
      slot.append(products);
    }
  }
  const scan = scope => scope.querySelectorAll('[data-eg-blog]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();